module.exports = __webpack_public_path__ + "static/media/firebase.d47db3c5.png";